export enum DeltaAgeType {
    Days = 1,
    Months = 2,
    Years = 3
}